class Gtm {
    constructor() {
        dataLayer = dataLayer || [];
        this.hasGtm = process.env.VUE_APP_GTM_CONTAINER_ID ? true : false;
    }
    push(event, action, label) {
        if (!this.hasGtm) {
            return;
        }
        dataLayer.push({
            event: event,
            action: action,
            label: label
        });
    }
    pushApiError(error) {
        if (error.response) {
            const method = error.config.method;
            const path = error.config.url
                .replace(process.env.VUE_APP_APIURL, '')
                .replace(/\/[0-9]+/g, '')
                .replace(/^\//, '')
                .replace(/\//g, '-');
            const status = error.response.status;
            this.push(
                'error',
                `api-${path}`,
                `error-${method}-status-${status}`
            );
        }
    }
    pushAmplitudeTracking(trackingInfo) {
        if (!this.hasGtm) {
            return;
        }
        trackingInfo.event = 'amplitude-pageview';
        dataLayer.push(trackingInfo);
    }
}
export default new Gtm();
